<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px"
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-card max-height="100%">  
      <v-card-title class="pa-3"> {{ title }} </v-card-title>

      <v-divider />
      <v-card-text class="px-3 pt-2" :style="{overflow: 'auto', height: $vuetify.breakpoint.height * 0.7 + 'px'}">
        <ServicesInput v-model="service_ids" :offered_ids="offered_ids" :claimed="currentPro.account_claimed" />
      </v-card-text>

      <v-divider />
      <!-- buttons -->
      <v-card-actions class="justify-center">
        <v-btn @click="close">Cancel</v-btn>
        <v-btn class="ml-3" color="primary" @click="saveClick">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { ServicesInput } from '@/components/inputs'
  import { ActivatorButton } from '@/components/pages'

  export default {
    name: 'ServicesDialog',

    components: { ActivatorButton, ServicesInput },

    data() {
      return {
        dialogVisible: false,
        service_ids: [],
        offered_ids: [],
      };
    },

    computed: {
      ...mapGetters('pros', ['currentPro']),
      ...mapGetters('services', ['by_category']),

      offered_services() { return this.pro.offered_services },

      title() { 
        if (this.currentPro.account_claimed) {
          return 'Restrict a Pro\'s Services'
        } else {
          return 'Choose a Pro\'s Services'
        }
      },
    },

    watch: {
      dialogVisible(visible) {
        if( visible ) {
          if (this.currentPro.account_claimed ) {
            this.service_ids = this.currentPro.offered_services.filter(s => s.blacklisted).map(s => s.service_id)
            this.offered_ids = this.currentPro.offered_services.map(s => s.service_id)
          } else {
            this.service_ids = this.currentPro.offered_services.map(s => s.service_id)
            this.offered_ids = []
          }
        }
      },
    },

    methods: {
      ...mapActions('pros', ['updateCurrentOfferedServices', 'updateCurrentBlacklistedServices']),

      close() {
        this.dialogVisible = false
      },

      async saveClick() {
        let result
        if (this.currentPro.account_claimed) {
          result = await this.updateCurrentBlacklistedServices(this.service_ids)
        } else {
          result = await this.updateCurrentOfferedServices(this.service_ids)
        }

        if (result.ok) { 
          this.close()
        }
      },
    },
  }
</script>

<style scoped>
  .v-dialog__content {
    position: absolute;
  }
</style>